import { Miniature, UserGroups } from '../../../models';

export interface IUserGroupFactory {
    createUserGroup(): any;
    getMiniatureList(): Miniature[];
}

export class UserGroupFactory implements IUserGroupFactory {

    static serviceId = 'userGroupFactory';

    groupFunctions: Miniature[];

    private _blank: Miniature;

    static $inject = [];
    constructor() {
        try {
            this._blank = new Miniature('addUserGroup', 'User group', 'fa-users', ['Create a new user group']);
            this.groupFunctions = [this._blank];
        } catch (e) {
            console.error(e);
        }
    }

    createUserGroup(): any {
        const group: UserGroups = <UserGroups>{};
        return group;
    }

    getMiniatureList(): Miniature[] {
        return this.groupFunctions;
    }
}